import { BaseDto } from "@app/modules/shared/model/base.dto";

export class EmailSettingsDto extends BaseDto {
  type: string;
  host_name: string;
  port_number: number;
  user_name: string;
  password: string;
  use_ssl: string;
  send_address: string;
  timeout: number;
}
